/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../utils/cn';

import style from './TextField.module.css';

const inputTypeWithLabel = ['date', 'datetime-local', 'month', 'time', 'week', 'datetime'];

const TextField = ({
  type, className, placeholder, name, value, icon, isValid, hasError, color, ...props
}) => (
  <label
    className={cn([
      className,
      style.wrapper,
      style[color],
      icon && style.hasIcon,
      hasError && style.hasError,
      isValid && style.isValid,
    ])}
    htmlFor={name}
  >
    {icon ? <i className={cn([style.icon, icon])} /> : null }
    <span className={cn([
      style.label,
      (value || inputTypeWithLabel.includes(type)) ? style.withValue : null,
    ])}
    >
      {placeholder}
    </span>
    <input
      id={name}
      name={name}
      className={cn([
        style.input,
        hasError && style.hasError,
        isValid && style.isValid,
      ])}
      type={type}
      placeholder=""
      value={value}
      {...props}
    />
  </label>
);

TextField.propTypes = {
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  icon: PropTypes.string,
  isValid: PropTypes.bool,
  hasError: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'secondary', 'accent', 'success', 'error', 'warning', 'grey', 'black']),
};

TextField.defaultProps = {
  className: null,
  icon: null,
  isValid: false,
  hasError: false,
  color: 'primary',
};

export default TextField;
